import { render, staticRenderFns } from "./AppSupportModal.vue?vue&type=template&id=42573a8c&"
import script from "./AppSupportModal.vue?vue&type=script&lang=ts&"
export * from "./AppSupportModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QStepper,QStep,QIcon,QSeparator,QStepperNavigation,QBtn} from 'quasar'
component.options.components = Object.assign({QStepper,QStep,QIcon,QSeparator,QStepperNavigation,QBtn}, component.options.components || {})
